// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1leJL","notes":"Notes_notes__2jSan","note":"Notes_note__1KWCz","markdown":"Notes_markdown__2laZi"};